export default "__VITE_PUBLIC_ASSET__726db262__"